import React, { useState } from "react"
import CardAno from "./components/CardAno"
import CardHoje from "./components/CardHoje"
import CardMensal from "./components/CardMensal"
import CardSemanal from "./components/CardSemanal"
import { useStyles } from "./style"

export default function AcompanhamentoVendas() {
  const classes = useStyles()

  const [pos, setPos] = useState(0)

  function setPosition(e) {
    setPos(e)
  }

  const Pages = [
    <CardAno setPosition={setPosition} />,
    <CardMensal setPosition={setPosition} />,
    <CardSemanal setPosition={setPosition} />,
    <CardHoje setPosition={setPosition} />
  ]

  return <>{Pages[pos]}</>
}
